<template>
  <div class="nc-top-layer translate" ref="parentRef">
    <template v-if="!disableDrawer">
      <div class="non-volatile-notification-layer" v-show="showDrawerOn">
        <div class="notification-wrapper-expanded"
             v-show="showDrawer"
             :style="{zIndex: baseZIndex + 2}"
        >
          <div class="drawer-header">
          <span class="drawer-header-text">
            Notifications <span class="drawer-close-button" @click="closeDrawer">X</span>
          </span>
          </div>

          <div class="drawer-content">
            <div class="w-100 h-100 flex-column">
              <div
                  v-for="item in persistQueue.queue"
                  class="drawer-notice"
                  :key="item.id"
                  :data-id="item.id"
                  :class="item.type">
                <slot
                    name="drawer"
                    :item="item"
                >
                  <b-card>
                    <b-card-header v-if="item.title">
                      <div v-html="item.title"></div>
                    </b-card-header>
                    <b-card-body v-if="item.text">
                      <div v-html="item.text"></div>
                    </b-card-body>
                    <b-card-footer v-if="item.footer"></b-card-footer>
                  </b-card>
                </slot>
              </div>
            </div>
          </div>
        </div>
        <div class="top-left-notification-layer" :style="{zIndex: baseZIndex + 1}">
          <b-icon
              v-show="!showDrawer"
              @click="openDrawer"
              icon="info-circle"
              class="open-drawer-info-icon"
              scale="2"
              id="open-drawer-info-icon">
          </b-icon>
        </div>
      </div>
    </template>
    <div class="volatile-notification-layer" :style="{zIndex: baseZIndex}">
      <!--    TOP MIDDLE -->
      <Toast
          ref="topRef"
          class="top"
          :animation="animationTop"
          :styles="styleTop"
          :max="max"
          :switchDelay="switchDelay"
      />
      <!--    TOP LEFT -->
      <Toast
          ref="topLeftRef"
          :animation="animationTopLeft"
          :styles="styleTopLeft"
          :max="max"
          :switchDelay="switchDelay"
      />
      <!--    TOP RIGHT -->
      <Toast
          ref="topRightRef"
          :animation="animationTopRight"
          :styles="styleTopRight"
          :max="max"
          :switchDelay="switchDelay"
      />
      <!--    BOTTOM -->
      <Toast
          ref="bottomRef"
          class="bottom"
          :animation="animationBottom"
          :styles="styleBottom"
          :max="max"
          :switchDelay="switchDelay"
      >
        <!--      <template v-slot:toast="props">-->
        <!--        <div class="custom-template" :class="[props.toast.type]">-->
        <!--&lt;!&ndash;          <div class="custom-template-icon" v-show="">&ndash;&gt;-->
        <!--&lt;!&ndash;            <i class="icon ion-android-checkmark-circle"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;          </div>&ndash;&gt;-->
        <!--          <div class="custom-template-content">-->
        <!--            <div class="custom-template-title">-->
        <!--              {{props.toast.title}}-->
        <!--            </div>-->
        <!--            <div class="custom-template-text"-->
        <!--                 v-html="props.toast.text"></div>-->
        <!--          </div>-->
        <!--&lt;!&ndash;          <div class="custom-template-close"&ndash;&gt;-->
        <!--&lt;!&ndash;               @click="props.close">&ndash;&gt;-->
        <!--&lt;!&ndash;            <i class="icon ion-android-close"></i>&ndash;&gt;-->
        <!--&lt;!&ndash;          </div>&ndash;&gt;-->
        <!--        </div>-->
        <!--      </template>-->
      </Toast>
      <!--    BOTTOM LEFT -->
      <Toast
          ref="bottomLeftRef"
          :animation="animationBottomLeft"
          :styles="styleBottomLeft"
          :max="max"
          :switchDelay="switchDelay"
      />
      <!--    BOTTOM RIGHT -->
      <Toast
          ref="bottomRightRef"
          :animation="animationBottomRight"
          :styles="styleBottomRight"
          :max="max"
          :switchDelay="switchDelay"
      />
    </div>
  </div>
</template>
<script>
import Toast, {Queue} from "@/module_social/components/notification/Toast";
import velocity from 'velocity-animate';
export const Id = (i => () => i++)(0);
export const POSITIONS = Object.freeze({
  TOP_RIGHT: 'top-right',
  TOP: 'top',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottom-left',
})

export default {
  components: { Toast },
  data() {
    return {
      // speed should be less than switchDelay
      switchDelay: 1000,
      speed: 800,
      max: 5,
      velocity: velocity,
      position: POSITIONS.TOP,
      showDrawer: false,
      persistQueue: new Queue(),
    }
  },
  props: {
    disableDrawer: { type: Boolean, default: true },
    showDrawerOn: { type: Boolean, default: true },
    baseZIndex: { type: Number, default: 1 },
    // converted to %
    maxToastWidth: { type: Number, default: 90},
    offsetBox: {
      type: Object, default: () => ({
        offsetTop: 15,
        offsetBottom: 15,
        offsetLeft: 15,
        offsetRight: 15,
      }), required: false
    }
  },
  computed: {
    animationTop() {
      return this.getAnimation(POSITIONS.TOP);
    },
    animationTopLeft() {
      return this.getAnimation(POSITIONS.TOP_LEFT);
    },
    animationTopRight() {
      return this.getAnimation(POSITIONS.TOP_RIGHT);
    },
    animationBottom() {
      return this.getAnimation(POSITIONS.BOTTOM);
    },
    animationBottomLeft() {
      return this.getAnimation(POSITIONS.BOTTOM_LEFT);
    },
    animationBottomRight() {
      return this.getAnimation(POSITIONS.BOTTOM_RIGHT);
    },
    styleTop() {
      return this.getStyle(POSITIONS.TOP);
    },
    styleTopLeft() {
      return this.getStyle(POSITIONS.TOP_LEFT);
    },
    styleTopRight() {
      return this.getStyle(POSITIONS.TOP_RIGHT);
    },
    styleBottom() {
      return this.getStyle(POSITIONS.BOTTOM);
    },
    styleBottomLeft() {
      return this.getStyle(POSITIONS.BOTTOM_LEFT);
    },
    styleBottomRight() {
      return this.getStyle(POSITIONS.BOTTOM_RIGHT);
    },
  },
  methods: {
    getStyle(position) {
      return (el) => {
        let { offsetTop, offsetBottom, offsetLeft, offsetRight} = this.offsetBox;
        let suffix = 'px';
        let style = {};
        style['width'] = 'max-content';
        style['max-width'] = Math.min(100, this.maxToastWidth) + '%';
        switch (position) {
          case POSITIONS.TOP:
            style['transform-origin'] = 'center center';
            style['left'] = '50%';
            style['transform'] = 'translateX(-50%)';
            style['top'] = offsetTop + suffix;
            break;
          case POSITIONS.TOP_LEFT:
            style['left'] =  offsetLeft + suffix;
            style['top'] = offsetTop + suffix;
            break;
          case POSITIONS.BOTTOM_LEFT:
            style['bottom'] = offsetBottom + suffix;
            style['left'] = offsetLeft + suffix;
            break;
          case POSITIONS.TOP_RIGHT:
            style['right'] =  offsetRight + suffix;
            style['top'] = offsetTop + suffix;
            break;
          case POSITIONS.BOTTOM_RIGHT:
            style['right'] = offsetRight + suffix;
            style['bottom'] = offsetBottom + suffix;
            break;
          default:
            style['transform-origin'] = 'center center';
            style['bottom'] = offsetBottom + suffix;
            style['left'] = '50%';
            style['transform'] = 'translateX(-50%)';
        }
        return style;
      }
    },
    getAnimation(position) {
      let animation = null;
      switch (position) {
        case POSITIONS.TOP:
          animation = {
            enter: (el, complete) => {
              this.velocity(el, {
                scale: [1, 0.2],
                opacity: [1, 0]
              }, {
                duration: this.speed,
                complete
              });
            },
            leave: (el, complete) => {
              this.velocity(el, {
                scale: [0.2, 1],
                opacity: [0, 1]
              }, {
                duration: this.speed,
                complete
              });
            }
          }
          break;
        case POSITIONS.TOP_RIGHT:
          animation = {
            enter: (el, complete) => {
              this.velocity(el, {
                translateX: [-this.offsetBox.offsetRight, 2*el.clientWidth],
              }, {
                duration: this.speed,
                complete
              });
            },
            leave: (el, complete) => {
              this.velocity(el, {
                translateX: [2*el.clientWidth, -this.offsetBox.offsetRight],
              }, {
                duration: this.speed,
                complete
              });
            }
          }
          break;
        case POSITIONS.TOP_LEFT:
          animation = {
            enter: (el, complete) => {
              this.velocity(el, {
                translateX: [this.offsetBox.offsetLeft, -2*el.clientWidth],
              }, {
                duration: this.speed,
                complete
              });
            },
            leave: (el, complete) => {
              this.velocity(el, {
                translateX: [-2*el.clientWidth, this.offsetBox.offsetLeft],
              }, {
                duration: this.speed,
                complete
              });
            }
          }
          break;

        case POSITIONS.BOTTOM_RIGHT:
          animation = {
            enter: (el, complete) => {
              this.velocity(el, {
                translateX: [-this.offsetBox.offsetRight, 2*el.clientWidth],
              }, {
                duration: this.speed,
                complete
              });
            },
            leave: (el, complete) => {
              this.velocity(el, {
                translateX: [2*el.clientWidth, -this.offsetBox.offsetRight],
              }, {
                duration: this.speed,
                complete
              });
            }
          }
          break;
        case POSITIONS.BOTTOM_LEFT:
          animation = {
            enter: (el, complete) => {
              this.velocity(el, {
                translateX: [this.offsetBox.offsetLeft, -2*el.clientWidth],
              }, {
                duration: this.speed,
                complete
              });
            },
            leave: (el, complete) => {
              this.velocity(el, {
                translateX: [-2*el.clientWidth, this.offsetBox.offsetLeft],
              }, {
                duration: this.speed,
                complete
              });
            }
          }
          break;
        default:
          // BOTTOM
          animation = {
            enter: (el, complete) => {
              this.velocity(el, {
                scale: [1, 0.2],
                opacity: [1, 0]
              }, {
                duration: this.speed,
                complete
              });
            },
            leave: (el, complete) => {
              this.velocity(el, {
                scale: [0.2, 1],
                opacity: [0, 1]
              }, {
                duration: this.speed,
                complete
              });
            }
          }
      }
      return animation;
    },
    addNotice(notice, position, addToDrawer=false) {
      if (addToDrawer) this.addToDrawer(notice);
      switch (position) {
        case POSITIONS.BOTTOM:
          this.$refs.bottomRef.addToast(notice);
          break;
        case POSITIONS.TOP_LEFT:
          this.$refs.topLeftRef.addToast(notice);
          break;
        case POSITIONS.TOP_RIGHT:
          this.$refs.topRightRef.addToast(notice);
          break;
        case POSITIONS.BOTTOM_LEFT:
          this.$refs.bottomLeftRef.addToast(notice);
          break;
        case POSITIONS.BOTTOM_RIGHT:
          this.$refs.bottomRightRef.addToast(notice);
          break;
        default:
          this.$refs.topRef.addToast(notice);
      }
    },
    addToDrawer(notice) {
      let copyNotice = {...notice};
      copyNotice.type = copyNotice.type || 'info';
      copyNotice.type = 'toast-' + copyNotice.type;
      this.persistQueue.enqueue(copyNotice);
    },
    closeDrawer() {
      this.showDrawer = false;
    },
    openDrawer() {
      this.showDrawer = true;
    },
  },
  mounted() {
    // ----- Testing START ----- //
    // let i = 0;
    // let show = true;
    // setInterval(() => show = !show, 5000);
    // Object.keys(POSITIONS)
    //     .forEach(position => {
    //       this.addNotice({
    //         title: 'message ' + i++,
    //         text: 'text',
    //         type: 'info',
    //         closeOnClick: true,
    //         duration: 1000000,
    //         showUntil() {
    //           return show;
    //         },
    //         showWhenever() {
    //           return show;
    //         },
    //         onStartedCallback(toast) {
    //           console.log('started:', toast.state);
    //         },
    //         onClosedCallback(toast) {
    //           console.log('closed:', toast.state);
    //         },
    //         onDestroyedCallback(toast) {
    //           console.log('destroyed:', toast.state);
    //         }
    //       }, POSITIONS[position]);
    //     })
    // setInterval(_ => {
    //   Object.keys(POSITIONS)
    //       .forEach(position => {
    //         this.addNotice({
    //           title: 'message ' + i++,
    //           text: 'text',
    //           type: 'info',
    //           duration: 10000,
    //           // onStartedCallback(toast) {
    //           //   console.log('started:', toast.state);
    //           // },
    //           // onClosedCallback(toast) {
    //           //   console.log('closed:', toast.state);
    //           // },
    //           // onDestroyedCallback(toast) {
    //           //   console.log('destroyed:', toast.state);
    //           // }
    //         }, POSITIONS[position]);
    //       })
    // }
    // , 1000);
    // ----- Testing END ----- //
  }
}
</script>
<style lang="scss">
.nc-top-layer {
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .non-volatile-notification-layer {
    position: relative;
    width: 100%;
    height: 100%;

    .top-left-notification-layer {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      .open-drawer-info-icon {
        position: absolute;
        bottom: 100px;
        right: 45px;
        padding: 12px 42px 12px 30px;
        color: #73bc45;
        height: 60px;
        pointer-events: auto;
        cursor: pointer;
      }
    }

    .notification-wrapper-expanded {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 200px;
      background-color: rgba(0, 0, 0, 0.2);
      color: black;
      pointer-events: auto;

      .drawer-header {
        position: absolute;
        box-sizing: border-box;
        top: 0;
        padding: 8px 32px 8px 16px;
        width: 100%;
        height: 48px;
        box-shadow: 0px 16px 49px rgb(20 21 19 / 15%);
        background-color: #73bd45;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        text-decoration: none;
        letter-spacing: 1px;

        .drawer-header-text {
          display: block;
          overflow: hidden;
          white-space: nowrap;
          word-wrap: normal;
          text-overflow: ellipsis;
        }

        .drawer-close-button {
          cursor: pointer;
          position: absolute;
          top: 0;
          right: 0;
          opacity: 0.75;
          outline: 0;
          border: none;
          padding: 12px 23px 8px 6px;
        }
      }

      .drawer-content {
        position: absolute;
        top: 41px;
        bottom: 0;
        border-top: 1px solid transparent;
        padding: 16px;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        direction: ltr;
        text-align: left;

        .drawer-notice {
          font-weight: 600;
          font-size: 10px;
          margin: 0 0 12px 0;
          .card-header {
            font-weight: 700;
            padding: 2px;
          }
          .card-body {
            padding: 5px;
          }
        }
      }
    }

  }

  .volatile-notification-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;

    .top, .bottom {
      .custom-template-content {
        padding: 2px 8px;
      }
    }
  }
}
</style>
